import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

const read = async (url, params, fallback, label) => {
  try {
    const res = await axiosInstance.get(url, { params });
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error loading ${label}`);
    return fallback;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error loading ${label}`);
    return fallback;
  }
};

const mutate = async (method, url, payload, label) => {
  try {
    const res = await axiosInstance[method](url, payload);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error ${label}`);
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error ${label}`);
    return null;
  }
};

export const getOrderRejections = (params) =>
  read("/api/admin/orderRejections", params, { rows: [], total: 0, page: 1, totalPages: 1 }, "order rejections");

// Full row including request/response payloads (the list endpoint excludes them).
export const getOrderRejection = (id) =>
  read(`/api/admin/orderRejections/${id}`, undefined, null, "rejection details");

export const updateOrderRejectionStatus = (id, status, notes) =>
  mutate("post", `/api/admin/orderRejections/${id}/status`, { status, notes }, "updating rejection status");
